export default function auth ({next, store }){
  const { user } = store.state.auth;
  if (!user) {
    return next({
      name: 'login'
    })
  }

  /*const requiredRoles = to.meta.roles;
  if (requiredRoles && !requiredRoles.includes(user.role)) {
    return next('/unauthorized'); // Redirect to unauthorized page if role is not allowed
  }*/

  return next()
}

/*
export function roleMiddleware({ to, from, next, store }) {
  const { user } = store.state;

  if (!user) {
    return next('/login'); // Redirect to login if no user is found
  }

  const requiredRoles = to.meta.roles;
  if (requiredRoles && !requiredRoles.includes(user.role)) {
    return next('/unauthorized'); // Redirect to unauthorized page if role is not allowed
  }

  return next();
}*/
